import React from 'react';
import '../styles/theme.css';
import '../styles/History.css';
import BruteHeader from '../components/BruteHeader';
import BruteFooter from '../components/BruteFooter';
import HistoryMasthead from '../components/HistoryMasthead';
import HistoryRunList from '../components/HistoryRunList';
/* IMPORTS */

function HistoryPage() {
  return (
    <div className="hi-root">
      <div className="hi-layout-1">
        <div id="historyheaderslot" className="hi-slot-historyheaderslot">
          <BruteHeader activePage={"History"} />
        </div>
        <div className="hi-layout-2">
          <div id="historymasthead" className="hi-slot-historymasthead">
            <HistoryMasthead />
          </div>
          <div id="historyrunlist" className="hi-slot-historyrunlist">
            <HistoryRunList />
          </div>
        </div>
        <div id="historyfooterslot" className="hi-slot-historyfooterslot">
          <BruteFooter />
        </div>
      </div>
    </div>
  );
}

export default HistoryPage;